

function QuadAreas(props) {
  return (

      <div class="col-sm-12 col-12 box-1"  data-aos="fade-up" data-aos-delay="300">
        <div class="row box">
            <div class="col-sm-1 col-12">
                <i class="fa fa-desktop" aria-hidden="true"></i>
            </div>
            <div class="col-sm-11 col-12">
                <h3><a href="services.html">{props.titulo}</a></h3>
                <p>{props.text1}</p>
                <p>{props.text2}</p>
            </div>
        </div>
      </div>
    
  );
}

export default QuadAreas;
